import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { TextAreaBox } from 'fw/forms';
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import { ActionButton, Button } from 'fw/components';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import UploadsConfig from './UploadsConfig';
import { QueueType } from 'areas/shared/consts';

class TaxInfo extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: ''
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete=
        (
            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
        ) ||
        this.state.form.isRenewal ||
        (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument || ((reviewUpload.upload.uploadKey === 'BusinessTax2' || reviewUpload.upload.uploadKey === 'PersonalTax2') && !this.state.form.secondYear); })
            && (this.state.form.otherFiles == null
                || this.state.form.otherFiles.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })));

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getTaxInfo'),
            save: API.Admin.url('/certification/saveTaxInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            yearBusinessFormed: this.state.form.yearBusinessFormed,
            businessTax1: this.state.form.businessTax1,
            businessTax2: this.state.form.businessTax2,
            personalTax1: this.state.form.personalTax1,
            personalTax2: this.state.form.personalTax2,
            // annualRevenue1: this.state.form.annualRevenue1,
            // annualRevenue1Year: this.state.form.annualRevenue1Year,
            // annualRevenue2: this.state.form.annualRevenue2,
            // annualRevenue2Year: this.state.form.annualRevenue2Year,
            otherFiles: this.state.form.otherFiles,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewUploads: this.state.form.reviewUploads,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            lastMonth: this.state.form.lastMonth,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        // If currentStep is disabled (fastTrack), then go to tab "Cert."
        const currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === "taxInfo");
        if (this.props.setupProps.tabs[currentStepIndex].disabled)
            this.props.handleTabSelect("businessCertification");

        this.focusControl && this.focusControl.focus();
    }

    handleReviewUpload = (formUpload) => {
        let form = this.state.form;
        var items = form.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        form["reviewUploads"] = items;

        this.updatePostData(form, true);
    }

    addAnotherTaxDocument = () => {
        let form = this.state.form;
        form.otherFiles.push({
            taxInformationOtherFileId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    };

    handleOtherDocumentRemove = (index) => {
        let form = this.state.form;

        form.otherFiles[index].description = "";
    };

    handleUploadOtherDocumentChange = (formUpload, index) => {
        let form = this.state.form;

        form.otherFiles[index].uploadModel = formUpload;

        this.updatePostData(form, true);
    };

    handleDescriptionChange = (value, index) => {
        let form = this.state.form;
        form.otherFiles[index].description = value;

        this.updatePostData(form, true);
    };

    handleRemoveOtherDocument = (i) => {
        let form = this.state.form;
        form.otherFiles.splice(i, 1);

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "TaxInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId,
                CurrentYear: this.state.form.currentYear,
                LastYear: this.state.form.lastYear,
                SecondYear: this.state.form.secondYear,
                LastMonth: this.state.form.lastMonth
            }
        });

        ReportManager.execute(rq);
    };

    renderOtherFiles = () => {
        return this.state.form.otherFiles.map((item, index) => (
            <Row key={item.taxInformationOtherFileId} style={{ marginBottom: 10 }}>
                <Col md={12}>
                    <ReviewUpload
                        reviewUpload={item.uploadModel}
                        reviewDisabled={this.state.form.isRenewal}
                        onChange={formUpload => this.handleUploadOtherDocumentChange(formUpload, index)}
                        notApplicableAvailable={false}
                        queueTypeCode={this.state.form.certificationQueueTypeCode} />
                </Col>
                <Col md={6}>
                    <TextAreaBox
                        required
                        rows={3}
                        value={item.description}
                        placeholder='Briefly describe your Uploaded Tax Document here...'
                        maxLength={500}
                        onChange={value => this.handleDescriptionChange(value, index)}
                        ref={`otherTaxFileDescription_${index}`}
                    />
                </Col>
                <Col md={1} style={{ marginTop: -40, textAlign: "left", marginLeft: -20, paddingLeft: 0 }}>
                    {this.state.enabled &&
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(index)} title="Remove Financial Document">
							<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
					}
                </Col>
            </Row>
        ));
    };

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'TAX'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderUploadFields = () => {
        var me = this;
        return this.state.form.reviewUploads.map((item, index) => (
            me.renderUploadField(item)
        ));
    }

    renderUploadField = (reviewUpload) => {
        const uploadKey = reviewUpload.upload.uploadKey;
        return (
            <React.Fragment>
                {(uploadKey === 'BusinessTax1' || uploadKey === 'PersonalTax1' || this.state.form.secondYear)
                    ? (<ReviewUpload
                        key={uploadKey}
                        reviewUpload={reviewUpload}
                        reviewDisabled={this.state.form.isRenewal}
                        config={UploadsConfig}
                        onChange={this.handleReviewUpload}
                        queueTypeCode={this.state.form.certificationQueueTypeCode}
                        tip={this.setTip(UploadsConfig[uploadKey].tooltipCode)}/>)
                    : null}
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Tax Information – <small>Please submit all required Tax documents</small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                {this.renderUploadFields()}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <label>&nbsp;</label>
                                <label>&nbsp;</label>
                                {this.state.form.otherFiles !== null && this.state.form.otherFiles.length > 0 && this.renderOtherFiles()}
                                {this.state.enabled && (this.state.form.otherFiles == null || this.state.form.otherFiles.length < 5) &&
									<Button type="button" bsStyle="link" onClick={this.addAnotherTaxDocument}>
                                        Add another Tax Document
									</Button>
								}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={"TAX"}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.savedEntityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange} />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Tax Information"
                                    canComplete={
                                        (
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                        this.state.form.isRenewal ||
                                        (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument || ((reviewUpload.upload.uploadKey === 'BusinessTax2' || reviewUpload.upload.uploadKey === 'PersonalTax2') && !this.state.form.secondYear); })
                                            && (this.state.form.otherFiles === null
                                                || this.state.form.otherFiles.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })))
                                    }
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment> 
                    : null}
            </React.Fragment>
        )
    }
}

export default TaxInfo; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/taxInfo/TaxInfo.js